<template>
  <router-link v-if="typeof to == 'object'" :to="to" :class="getClasses()"
    :style="getStyles()">
    <slot />
  </router-link>
  <a v-else-if="typeof to == 'string'" :to="to" :href="to" :class="getClasses()"
    :style="getStyles()">
    <slot />
  </a>
  <button v-else @click="$emit('click')" :type="type" :class="getClasses()"
    :style="getStyles()" :data-bs-dismiss="databsdismiss" :data-bs-target="databstarget" :data-bs-toggle="databstoggle" :disabled="disabled">
    <slot />
  </button>
</template>
<style scoped lang="sass">
a
  color: #fff!important
.btn-outline
  color: #0385F3!important
</style>
<script>
export default {
  name: "argon-button",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    databstarget: {
      type: String,
      required: false,
    },
    databstoggle: {
      type: String,
      required: false,
    },
    databsdismiss: {
      type: String,
      required: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "submit",
    },
    btnstyle: {
      type: String,
      default: "button",
    },
    to: {
      required: false,
    },
    textcolor: {
      type: String,
      default: "#fff"
    },
    color: {
      type: String,
      default: "#0385F3",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getStyles() {
      const style = []
      if (this.outline) {
        if (this.color.startsWith('#')) style.push(`border: solid ${this.color}`)
      } else if (this.btnstyle == "button") {
        if (this.color.startsWith('#')) style.push(`background-color: ${this.color}`)
        if (this.textcolor.startsWith('#')) style.push(`color: ${this.textcolor}`)
      } else if (this.textcolor == "#fff") {
        style.push(`color: #0385F3`)
      } else if (this.textcolor.startsWith('#')) {
        style.push(`color: ${this.textcolor}`)
      }
      style.push('border-radius: 0.3rem')
      return style.join(";")
    },
    getClasses() {
      let classes = {};
      classes['mb-0'] = true;
      
      if (!this.color.startsWith('#')) {
        switch (this.variant) {
          case "gradient":
            classes[`bg-${this.variant}-${this.color}`] = true;
            break;
          case "outline":
            classes[`btn-${this.variant}-${this.color}`] = true;
            break;
          default:
            classes[`btn-${this.color}`] = true;
            break;
        }
      }

      if (this.outline) {
        classes[`btn-outline`] = true;
      }

      switch (this.btnstyle) {
        case "link":
          classes['btn-link'] = true;
          break;
        case "button":
          classes['btn'] = true;
          break;
      }

      if (this.size) classes[`btn-${this.size}`] = true;

      if (this.fullWidth) classes[`w-100`] = true;

      if (this.active) classes[`active`] = true;

      return classes;
    },
  },
};
</script>
